import React from 'react'
import Product from '../Components/Product'
import SkincareProducts from '../Json/SkincareProducts.json'

const SkinCare = () => {
    console.log(SkincareProducts)
  return (
    <div><Product productsList={SkincareProducts}/></div>
  )
}

export default SkinCare